import { render } from "./B2bPageCmrDraft.vue?vue&type=template&id=8321b496&scoped=true&lang=pug"
import script from "./B2bPageCmrDraft.vue?vue&type=script&lang=js"
export * from "./B2bPageCmrDraft.vue?vue&type=script&lang=js"

import "./B2bPageCmrDraft.vue?vue&type=style&index=0&id=8321b496&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8321b496"]])

export default __exports__